// address-completion.service.ts
import { Injectable, InjectionToken, signal } from '@angular/core';
import { GetAddress } from '../app-types/address.app';
import { BaseRequestService } from './base-request.service';

@Injectable()
export class AddressCompletionService extends BaseRequestService {
	public readonly requests = signal<string[]>([]);

	/**
	 * Asks for address suggestions
	 * @param query  Postalcode, City, Street and Housenumber
	 * @returns returns 5 possible AddressItems
	 */
	public suggest = async (query: string): Promise<GetAddress[]> => {
		try {
			this.requests.update((request) => [...request, 'suggestAddress']);
			const params = { addressQueryString: query };
			const apiResult = await this.get<GetAddress[]>('address/autocomplete/', params);
			return apiResult;
		} finally {
			this.requests.update((request) => request.filter((request) => request !== 'suggestAddress'));
		}
	};
}

export const ADDRESS_COMPLETION_SERVICE = new InjectionToken<AddressCompletionService>('ADDRESS_COMPLETION_SERVICE');
